import React from "react";
import { Search, X } from "lucide-react";

/**
 * Search input with leading icon and optional clear control.
 */
export default function SearchField({
  value,
  onChange,
  placeholder = "Search by name",
  label = "Search by name",
  testId,
  clearTestId,
  className = "",
  inputClassName = "",
}) {
  return (
    <label className={`relative block ${className}`.trim()}>
      <span className="sr-only">{label}</span>
      <Search
        className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-ink/40 pointer-events-none"
        strokeWidth={2.5}
        aria-hidden
      />
      <input
        type="search"
        className={`field field-leading-icon w-full ${value ? "pr-10" : ""} ${inputClassName}`.trim()}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        data-testid={testId}
      />
      {value ? (
        <button
          type="button"
          onClick={() => onChange("")}
          className="absolute right-1 top-1/2 -translate-y-1/2 inline-flex items-center justify-center min-w-[36px] min-h-[36px] rounded-sm text-ink/50 hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-plum"
          aria-label="Clear search"
          data-testid={clearTestId}
        >
          <X className="w-4 h-4" strokeWidth={2.5} aria-hidden />
        </button>
      ) : null}
    </label>
  );
}
